module.exports = __webpack_public_path__ + "img/美的置业.bab3a5d7.png";